import { render, staticRenderFns } from "./CTTatDashboard.vue?vue&type=template&id=0a82f458&scoped=true"
import script from "./CTTatDashboard.vue?vue&type=script&lang=js"
export * from "./CTTatDashboard.vue?vue&type=script&lang=js"
import style0 from "./CTTatDashboard.vue?vue&type=style&index=0&id=0a82f458&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a82f458",
  null
  
)

export default component.exports